import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredArticles = articles.slice(0, 4);

export default function ArticleHighlight() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            久久久久精选内容
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            阅读久久久久的深度文章，了解持久稳定体验背后的理念与实践
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="w-full sm:w-48 h-48 sm:h-auto flex-shrink-0">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col justify-between flex-1">
                <div>
                  <span className="inline-block px-2 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded mb-3">
                    {article.categoryName}
                  </span>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {article.summary}
                  </p>
                </div>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/quality"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}